import { render } from "./StartVote.vue?vue&type=template&id=75a70bbc&scoped=true"
import script from "./StartVote.vue?vue&type=script&lang=js"
export * from "./StartVote.vue?vue&type=script&lang=js"

import "./StartVote.vue?vue&type=style&index=0&id=75a70bbc&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a70bbc"]])

export default __exports__